document.addEventListener('alpine:init', () => {
  Alpine.store('cart', {
    quantity: window.cartItemCount || 0,
    init() {
      // Only fetch if we don't have an initial value
      if (this.quantity === null || this.quantity === undefined) {
        this.fetchCartData();
      }
    },
    fetchCartData() {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
        .then((res) => res.json())
        .then((data) => {
          this.quantity = data.item_count;
        })
        .catch(() => {
          // Fallback to current value on error
          this.quantity = this.quantity || 0;
        });
    },
    incrementQty(value) {
      this.quantity += value;
    },
    decrementQty(value) {
      this.quantity -= value;
    },
    updateQty(value) {
      this.quantity = value;
    },
    refresh() {
      this.fetchCartData();
    },
  });

  // Refresh cart data when user returns to the page (e.g., from checkout)
  let isInitialLoad = true;
  window.addEventListener('focus', () => {
    // Skip the initial focus event when page loads
    if (isInitialLoad) {
      isInitialLoad = false;
      return;
    }

    // Refresh cart store when user returns to the page
    Alpine.store('cart').refresh();
  });

  // Also refresh on page visibility change (for mobile)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !isInitialLoad) {
      Alpine.store('cart').refresh();
    }
  });
});
